import React,{useState,useEffect} from 'react';
import { Link,useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { addItemsToCart,removeItemsFromCart } from "../actions/cartAction";
import {setCache,getCache} from './cache.js';

const Cart = () => {

	const dispatch = useDispatch();
  	const { cartItems } = useSelector((state) => state.cart);
    // console.log(cartItems)
    const navigate = useNavigate();

  	const increaseQuantity = (id, quantity, stock) => {
	    const newQty = quantity + 1;
	    if (stock <= quantity) {
	      return;
	    }
	    dispatch(addItemsToCart(id, newQty));
	};

	const decreaseQuantity = (id, quantity) => {
	    const newQty = quantity - 1;
	    if (1 >= quantity) {
	      return;
	    }
	    dispatch(addItemsToCart(id, newQty));
	};

	const deleteCartItems = (id) => {
	    dispatch(removeItemsFromCart(id));
	};

    const checkoutHandler = () => {
        navigate("/shipping");
    };

    const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  // Country-to-Currency mapping with exchange rates
  // const countryToCurrency = {
  //   PK: { symbol: "₨", rate: 380 },
  //   US: { symbol: "$", rate: 1.2 },
  //   FR: { symbol: "€", rate: 1.15 },
  //   IN: { symbol: "₹", rate: 100 },
  //   GB: { symbol: "£", rate: 1 },
  // };

  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

  //   const fetchExchangeRates = async () => {
  //     try {
  //       const response = await fetch(API_URL);
  //       if (!response.ok) throw new Error("Failed to fetch exchange rates");
  //       const data = await response.json();

  //       setCountryToCurrency((prev) => {
  //         const updatedCurrencies = { ...prev };

  //         Object.keys(updatedCurrencies).forEach((country) => {
  //           const currencyCode = updatedCurrencies[country].currencyCode;
  //           const rate = data.rates[currencyCode];
  //           if (rate) {
  //             updatedCurrencies[country].rate = rate;
  //           }
  //         });

  //         return updatedCurrencies;
  //       });
  //     } catch (error) {
  //       console.error("Error fetching exchange rates:", error);
  //     }
  //   };

  //   // Fetch user's country using their IP address
  //   const fetchUserCountry = async () => {
  //   try {
  //     const response = await fetch("https://get.geojs.io/v1/ip/country.json");
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  //     const data = await response.json();
  //     return data.country || "GB";
  //   } catch (error) {
  //     console.error("Error fetching user country:", error);
  //     return "GB"; // Default to GB on failure
  //   }
  // };


  //   const loadCurrencyDetails = async () => {
  //   setIsLoading(true);
  //   await fetchExchangeRates();
  //   const userCountry = await fetchUserCountry();
  //   setCountryCode(userCountry);
  //   // Use updated rates
  // setCountryToCurrency((prev) => {
  //   const currencyInfo = prev[userCountry] || prev["GB"]; // Default to GBP if country not found
  //   setCurrencySymbol(currencyInfo.symbol || "£");
  //   return prev;
  // });
  //   setIsLoading(false);
  // };

  // useEffect(() => {
  //   loadCurrencyDetails();
  // }, []);

    const CACHE_DURATION = 1 * 10;

    const fetchExchangeRates = async () => {
  const cacheKey = `ExchangeRates:${new Date().toISOString().split('T')[0]}`;
  console.log(`[FETCH] Generated Cache Key: ${cacheKey}`);
  const cachedData = getCache(cacheKey);
  console.log(cachedData)
  if (cachedData) {
    console.log("Exchange rates fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch(API_URL);
    if (!response.ok) throw new Error("Failed to fetch exchange rates");

    const data = await response.json();
    setCache(cacheKey, data, CACHE_DURATION);
    console.log("Exchange rates fetched from API");
    return data;
  } catch (error) {
    console.error("Error fetching exchange rates:", error);
    throw error;
  }
};

// Fetch user's country with caching
const fetchUserCountry = async () => {
  const cacheKey = "UserCountry";
  const cachedData = getCache(cacheKey);

  if (cachedData) {
    console.log("User country fetched from cache",new Date());
    return cachedData;
  }

  try {
    const response = await fetch("https://get.geojs.io/v1/ip/country.json");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    const country = data.country || "GB";
    setCache(cacheKey, country, CACHE_DURATION);
    console.log("User country fetched from API");
    return country;
  } catch (error) {
    console.error("Error fetching user country:", error);
    return "GB"; // Default to GB on failure
  }
};

// Load currency details with caching
const loadCurrencyDetails = async () => {
  setIsLoading(true);

  try {
    const exchangeRates = await fetchExchangeRates();
    const userCountry = await fetchUserCountry();

    setCountryToCurrency((prev) => {
      const updatedCurrencies = { ...prev };

      Object.keys(updatedCurrencies).forEach((country) => {
        const currencyCode = updatedCurrencies[country].currencyCode;
        const rate = exchangeRates.rates[currencyCode];
        if (rate) {
          updatedCurrencies[country].rate = rate;
        }
      });

      const currencyInfo = updatedCurrencies[userCountry] || updatedCurrencies["GB"];
      setCurrencySymbol(currencyInfo.symbol || "£");

      return updatedCurrencies;
    });

    setCountryCode(userCountry);
  } catch (error) {
    console.error("Error loading currency details:", error);
  } finally {
    setIsLoading(false);
  }
};

// React useEffect to load data on mount
useEffect(() => {
  loadCurrencyDetails();
}, []);

	return (
		<>
		{cartItems.length === 0 ? (
	
		    <div className="section section-padding cart_sec">
		        <div className="container">
		            <div className="cart-wrapper">
		                
		                <div className="empty-cart text-center">
		                    <h2 className="empty-cart-title">
		                        There are no more items in your cart
		                    </h2>
		                    <div className="empty-cart-img">
		                        <img src="assets/images/cart.png" alt="Cart" />
		                    </div>
		                    <p>Your cart is currently empty!</p>
		                    <Link to="/shop" className="btn btn-primary btn-hover-dark"><i className="fa fa-angle-left"></i> Continue
		                        Shopping</Link>
		                </div>
		                
		            </div>
		        </div>
		    </div>
		    
      ) : (
      <>
			{/*<!-- Shopping Cart Section Start -->*/}
    <div className="section section-padding cart_sec">
        <div className="container">
            <div className="cart-wrapper">
                {/*<!-- Cart Wrapper Start -->*/}
                <div className="cart-table table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="product-thumb">Image</th>
                                <th className="product-info">
                                    Course Information
                                </th>
                                {/*<th className="product-quantity">Quantity</th>*/}
                                <th className="product-total-price">
                                    Total Price
                                </th>
                                <th className="product-action">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                        	cartItems && cartItems.map((item) => {

                                const rate =
                        countryToCurrency[countryCode]?.rate || 1;
                      const localizedItemPrice = (
                        item.price * item.quantity * rate
                      ).toFixed(2);

                                return (

                        		<tr key={item.product}>
	                                <td className="product-thumb">
	                                    <img src={item.image} alt="" />
	                                </td>
	                                <td className="product-info">
	                                    <h6 className="name">
	                                        <Link to={`/product/${item.product}`}>{item.topic}</Link>
	                                    </h6>
	                                    {/*<div className="product-prices">
	                                        <span className="sale-price"
	                                                >{`£${item.price}`}</span>
	                                    </div>*/}
	                                   {/* <div className="product-size-color">
	                                        <p>Size <span>S</span></p>
	                                        <p>Color <span>White</span></p>
	                                    </div>*/}
	                                </td>
	                                {/*<td className="quantity">
	                                    <div className="product-quantity d-inline-flex">
	                                        <button onClick={() =>decreaseQuantity(item.product, item.quantity)} className="sub">
	                                            -
	                                        </button>
	                                        <input type="text" value={item.quantity} readOnly />
	                                        <button onClick={() =>increaseQuantity(item.product,item.quantity,item.stock)} className="add">
	                                            +
	                                        </button>
	                                    </div>
	                                </td>*/}
	                                <td className="product-total-price">
	                                    <span className="price">
                                          £{item.price}
                                        </span>
                                        {currencySymbol !== "£" && (
                                            <small className="d-block">
                                                {currencySymbol} {localizedItemPrice}
                                            </small>
                                        )}
	                                </td>
	                                <td className="product-action">
	                                    <button className="remove" onClick={() => deleteCartItems(item.product)}>
	                                        <i className="pe-7s-trash"></i>
	                                    </button>
	                                </td>
	                            </tr>

                        	);
                                
                        })}
                        <tr>
                            <td></td>
                            <td><h6>Total Price</h6></td>
                            <td>
                                <h4 className="text-center">
                                  {`£ ${cartItems
                                          .reduce(
                                            (acc, item) => acc + item.quantity * item.price , 0)
                                    }`}
                                </h4>
                                {currencySymbol !== "£" && (
                                    <small className="text-center d-block">
                                        {currencySymbol}{" "}
                                        {cartItems
                                            .reduce(
                                                (acc, item) =>
                                                    acc +
                                                    item.quantity *
                                                    item.price *
                                                    (countryToCurrency[countryCode]?.rate || 1),
                                                0
                                            )
                                            .toFixed(2)}
                                    </small>
                                    )}
                              </td>
                            <td></td>
                        </tr>
                            
                            
                        </tbody>
                    </table>
                </div>
                {/*<!-- Cart Wrapper End -->*/}
                {/*<!-- Cart btn Start -->*/}
                <div className="cart-btn">
                    <div className="left-btn">
                        <Link to="/" className="btn btn-dark btn-hover-primary">Continue Shopping</Link>
                    </div>
                    <div className="right-btn">
                        <button onClick={checkoutHandler} className="btn btn-outline-dark">Proceed To Checkout</button>
                    </div>
                </div>
                {/*<!-- Cart btn Start -->*/}
            </div>
            <div className="row">
                

                <div className="col-lg-4">
                    {/*<!-- Cart Totals Start -->*/}
                    <div className="cart-totals">
                        {/*<div className="cart-title">
                            <h4 className="title">Cart totals</h4>
                        </div>*/}
                        {/*<div className="cart-total-table">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <p className="value">Subtotal</p>
                                        </td>
                                        <td>
                                            <p className="price">£600.00</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className="value">Shipping</p>
                                        </td>
                                        <td>
                                            <ul className="shipping-list">
                                                <li className="radio">
                                                    <input type="radio" name="shipping" id="radio1" checked="" />
                                                    <label for="radio1"><span></span> Flat
                                                        Rate</label>
                                                </li>
                                                <li className="radio">
                                                    <input type="radio" name="shipping" id="radio2" />
                                                    <label for="radio2"><span></span> Free
                                                        Shipping</label>
                                                </li>
                                                <li className="radio">
                                                    <input type="radio" name="shipping" id="radio3" />
                                                    <label for="radio3"><span></span> Local
                                                        Pickup</label>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className="value">Total</p>
                                        </td>
                                        <td>
                                            <p className="price">£600.00</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>*/}
                        {/*<div className="cart-total-btn">
                            <Link to="#" className="btn btn-dark btn-hover-primary btn-block">Proceed To Checkout</Link>
                        </div>*/}
                    </div>
                    {/*<!-- Cart Totals End -->*/}
                </div>
            </div>
        </div>
    </div>
    {/*<!-- Shopping Cart Section End -->*/}	
    </>
    )}
		</>
	)
}

export default Cart